import React from 'react';
import PageButton from '../../elements/PageButton/PageButton';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {ShopFactionBuyButton} from '../ShopPage/ShopPage';
import NotEnoughCrystalsModal from '../ShopPage/NotEnoughCrystalsModal/NotEnoughCrystalsModal';
import ChestPurchaseModal from '../../Modals/ChestPurchaseModal/ChestPurchaseModal';
import FactionPurchaseRewardModal from '../../Modals/FactionPurchaseRewardModal/FactionPurchaseRewardModal';

// Чем грозит уход «за кристаллами» в магазин из выбора фракции — это переход
// на другой экран целиком: в сетевом лобби рвется соединение с ним, в
// локальной игре теряется несохраненная настройка
export const TEXT_SHOP_LEAVES_LOCAL_MATCH = 'Переход в магазин сбросит все выборы, сделанные для текущего локального матча.';
export const TEXT_SHOP_LEAVES_LOBBY = 'Переход в магазин отключит вас от текущего лобби.';

/**
 * Кнопка вместо «Выбрать» у фракции, которую выбрать нельзя, — точно так же,
 * как в магазине (ShopFactionsTab): уже реализованная, но не открытая —
 * покупка за кристаллы; ещё не реализованная — «Получить», открывающая
 * Сундук Вечности (в тех же состояниях уже купленности/открытости, что и в
 * самом магазине).
 *
 * Функция, а не компонент: вызывающий (карусель) по пустому ответу рисует
 * свою обычную кнопку выбора, а элемент компонента пустым не бывает.
 *
 * @param {Object} params
 * @param {Object} params.item - элемент списка (useFactionSelectList)
 * @param {boolean} params.isAvailable - фракцию можно выбрать
 * @param {boolean} params.isBanned - забанена в рейтинговом лобби
 * @param {Object} params.purchase - useFactionSelectPurchase
 * @param {string} params.pageId - страница для аналитики
 * @param {string} [params.className] - класс кнопки «Получить»
 * @returns {React.ReactElement|null}
 */
// Второй и следующие щелчки многократного нажатия (event.detail > 1) —
// не согласие на покупку: в десктопном лобби двойной щелчок по закрытой
// фракции в сетке первым щелчком переключает на карусель, и второй приходился
// бы ровно на появившуюся на его месте кнопку «Купить» — кристаллы списались
// бы без взгляда на цену. Одиночный щелчок покупает, как и раньше
const checkIfRepeatedClick = (event) => Boolean(event) && event.detail > 1;

export const renderFactionLockedSelectButton = ({item, isAvailable, isBanned, purchase, pageId, className}) => {
  if (isAvailable) return null;
  // Забаненная фракция у игрока уже есть — предлагать купить ее за кристаллы
  // нельзя: вызывающий рисует обычную (заблокированную) кнопку выбора
  if (isBanned) return null;

  if (!item.implemented) {
    return (
      <PageButton
        className={className}
        onClick={(event) => {
          if (checkIfRepeatedClick(event)) return;
          MENU_SOUND_MANAGER.playChestEternal();
          purchase.setIsEternalChestOpen(true);
        }}
        pageId={pageId}
        buttonId={`get_eternal_${item.id}`}
        noSound
      >
        Получить
      </PageButton>
    );
  }

  return (
    <ShopFactionBuyButton
      faction={item}
      isOverlayMode={true}
      showBuyPrefix={false}
      buttonIdSuffix="_carousel"
      pageId={pageId}
      onBuy={(event) => {
        if (checkIfRepeatedClick(event)) return;
        purchase.handleBuyFaction(item.id);
      }}
    />
  );
};

/**
 * Модалки покупки из выбора фракции: награда за купленную фракцию, Сундук
 * Вечности и нехватка кристаллов (состояния — useFactionSelectPurchase).
 *
 * @param {Object} props
 * @param {Object} props.purchase - useFactionSelectPurchase
 * @param {string} props.insufficientCrystalsWarningText - чем грозит уход в магазин
 * @param {Function} [props.onGoToCrystals]
 * @param {Function} [props.onOpenInventory]
 */
const FactionSelectPurchaseModals = ({purchase, insufficientCrystalsWarningText, onGoToCrystals, onOpenInventory}) => (
  <>
    {purchase.purchasedFactionId && (
      <FactionPurchaseRewardModal
        factionId={purchase.purchasedFactionId}
        onClaim={() => purchase.setPurchasedFactionId(null)}
      />
    )}

    {purchase.isEternalChestOpen && (
      <ChestPurchaseModal
        chest={purchase.eternalChestConfig}
        onClose={() => purchase.setIsEternalChestOpen(false)}
        onPurchase={purchase.handleBuyChest}
        onOpenInventory={onOpenInventory}
        alreadyOwned={purchase.isEternalOpened}
      />
    )}

    {purchase.notEnoughCrystalsAmount != null && (
      <NotEnoughCrystalsModal
        missingAmount={purchase.notEnoughCrystalsAmount}
        warningText={insufficientCrystalsWarningText}
        onGoToCrystals={() => {
          purchase.clearNotEnoughCrystals();
          purchase.setIsEternalChestOpen(false);
          onGoToCrystals?.();
        }}
        onClose={purchase.clearNotEnoughCrystals}
      />
    )}
  </>
);

export default FactionSelectPurchaseModals;
